import React, { Component } from 'react';
import axios from 'axios';
import '../../Asset/Css/Site.css';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Modal, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { config } from '../../Constants';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import global from '../global';
import Spinner from '../Spinner';
import EasyDividendLogo from '../../Asset/Images/easy-dividend-logo.png';
import goBack from '../../Asset/Images/previous-icon.png';

export class SignIn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isVerified: false,
            Email: '',
            Password: '',
            isAdmin: 'block',
            loading: false,
            URL: config.url.Web_URL
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        
        const { name, value } = e.target;
        this.setState({ [name]: value });       
    }
    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    handleSubmit = (e) => {
        debugger

        if (this.state.Email == "" || this.state.Email == null) {
            this.showNoti("Notification", "Email is required.", "warning");
            return;
        }

        if (this.state.Password == "" || this.state.Password == null) {
            this.showNoti("Notification", "Password is required.", "warning");
            return;
        }

        if (this.state.Email !== "") {
            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (!regex.test(this.state.Email)) {
                this.showNoti("Notification", "Invalid Email Address.", "danger");
                return;
            }
        }

        this.setState({ loading: true });

        const sendOTPEmail = this.state;

        axios.post(global.UserManagement.SignInAPI, sendOTPEmail)
            .then(json => {
                this.state.flag = 1;
                if (json.data.status) {
                    debugger                 
                    if (json.data.redirectFlag == "SKP") {
                        window.location.href = config.url.Web_URL + '/Nexdigm/Dashboard';
                        this.setState({ loading: false });
                    }
                    else {
                        window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(json.data.AssignmentCode) + '&flag=' + window.btoa(this.state.flag);
                        this.setState({ loading: false });
                    }
                }
                else {  
                    this.setState({ loading: false });
                    this.showNoti("Notification", json.data.message, "danger");                    
                }
            })

    }

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }

    render() {

        if (this.state.loading) return <Spinner />;

        return (
            <div>
                <ReactNotification />

                <div className="main-bg">
                    <img src={EasyDividendLogo } alt="Logo" className="logo-img"/>
                    <div className="sub-main-w3">
                        <div className="image-style">

                        </div>

                        <div className="vertical-tab">
                            <div className="section-w3ls">
                                <input type="radio" name="sections" id="option1" onClick={this.state.URL + "/SignIn"} checked />
                                <label for="option1" className="icon-left-w3pvt"><span className="fa fa-user-circle" aria-hidden="true"></span>Sign In</label>
                                <article>
                                    <div className="form h-430">
                                        <h3 className="legend">Sign In</h3>

                                        <Row>
                                            <Col md={12}>
                                                <label className="required-field m-t-20">Email</label>
                                                <FormControl type="email" name="Email" key="txtEmail" className="m-t-10"
                                                    value={this.state.Email}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 100 Characters"
                                                    maxLength="100"
                                                    autoCompleteto="off"
                                                />
                                            </Col>

                                            <Col md={12}>
                                                <label className="required-field m-t-20">Password</label>
                                                <FormControl type="password" name="Password" className="m-t-10" maxLength="100"
                                                    value={this.state.Password}
                                                    onChange={this.handleChange}
                                                    placeholder="Max 50 Characters"
                                                    autoCompleteto="new-password"
                                                />
                                            </Col>
                                            <Col md={12} className="m-t-20">
                                                <button type="submit" className="btn submit last-btn" onClick={this.handleSubmit}>Login</button>
                                            </Col>
                                        </Row>
                                    </div>
                                </article>
                            </div>
                            <a href={this.state.URL + "/SignUp"} className="section-w3ls">
                                <input type="radio" name="sections" onClick={this.state.URL + "/SignUp"} />
                                <label className="icon-left-w3pvt"><span className="fa fa-pencil-square" aria-hidden="true"></span>Sign Up</label>
                            </a>
                            <a href={this.state.URL + "/ResetPassword"} className="section-w3ls">
                                <input type="radio" name="sections" onClick={this.state.URL + "/ResetPassword"} />
                                <label className="icon-left-w3pvt"><span className="fa fa-lock" aria-hidden="true"></span>Forgot Password?</label>
                            </a>
                        </div>
                        <div className="clear"></div>
                        <img src={goBack} class="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />


                    </div>
                </div>
            </div>
        );
    }
}